/*
** $Id$
**
** Copyright 2019 Port25 Solutions, Inc.
** All rights reserved.
*/


const availableCommands = {
    'clear dnscache': `This command clears PowerMTA's internal DNS cache, removing all entries for the given domain. If the domain is * all cached DNS data is discarded. On Unix the asterisk must be escaped with a backslash.`,

    'clear secretscache': `This command clears PowerMTA's internal Vault secrets cache, removing all entries.`,

    'check mfrom': `This command has been deprecated since PowerMTA v4.5r10 because the Sender-ID standard checking performed by this command is obsolete. Please use check spf instead.`,

    'check spf': `This command checks whether a message with the given sender would pass the SPF check if sent from the given IP address. If the mailFrom parameter is specified, it will be used as the identity to check, else the heloDomain identity is checked.
            
Options:

--tcp

    use TCP (rather than the default UDP) for querying the name server(s).

--dumppackets

    print out a hexadecimal dump of any DNS queries and responses exchanged with the name servers. It is ignored unless the output is in text format.
`,
            delete: `Deletes recipients from the queue. Although --queue's default is */*, the command requires either --queue or --jobId to be entered explicitly, so that an accidental pmta delete command doesn't delete the entire queue. Messages are marked in the accounting file as deleted by administrator.

Options:

--dsn

    specifies that a DSN report should be sent. Using this option may slow the deletion process. No entry is written to the accounting file unless the --accounting flag is used as well.

--queue

    specifies which queue(s) to delete from, and defaults to all queues.

--orig

    specifies that only recipients with the given MAIL FROM address be deleted

--rcpt

    specifies that only recipient(s) with the given address are to be deleted

--jobId

    specifies that only recipients with the given Job ID are to be deleted

--envId

    specifies that only recipients with the given Envelope ID are to be deleted

--no-accounting

    specifies that deletion information will not be written to the accounting file

--older-than

    deletes all the recipients in the given queue that are older than the given from the current time. The syntax for the time interval is same as the syntax used to specify bounce-after in the configuration file.
`,

        'deregister': `Deregisters a node for PowerMTA Management Console. This command will delete all data that has not yet been loaded into PowerMTA Management Console. This does not effect the user configured accounting files.

Options:

--user

    specifies the PowerMTA Management Console user account to use when deregistering

--local-only

    only deregisters locally, registration will still exist in PowerMTA Management Console.

--retain-unloaded

    prevents deleting accounting files that have not yet been loaded from PowerMTA into PMC. Useful when needing to deregister and then reregister without losing any data.
`,

        'disable source': `Disables the given source IP from being used for delivering email from the given queue.`,

        'enable source': `Enables the given source IP to be used for delivering email from the given queue.`,

        'list': `Lists recipients matching the provided options.

Options:

--queue

    specifies which queue(s) to list from, and defaults to all queues.

--orig

    specifies that only recipients with the given MAIL FROM address be listed

--rcpt

    specifies that only recipients with the given RCPT TO address are to be listed.

--jobId

    specifies that only recipients with the given Job ID are to be listed

--envId

    specifies that only recipients with the given Envelope ID are to be listed.

--maxitems=n

    specifies the maximum number of recipients to be displayed in the output. By default 100 recipients are displayed.

--pause

    if recipient is being actively delivered, pause the delivery to enable showing the recipient in the output

--priority

    display the priority of each recipient in the output of the command

--schedule

    display the per-recipient schedule in the output of the command

--older-than=<time interval>

    displays recipients that have been in the queue for longer than the specified time interval. For example, --older-than=24h will list all recipients that have been in the queue for longer than 24 hours. Other examples of valid time intervals are 6h, 2h15m, 4d12h.
`,

        'pause queue': `Pause delivery of messages for the given queue and prevents them from being delivered until they are resumed.`,

        'pause job': `Pause delivery of messages for the given jobID, and prevents them from being delivered until they are resumed.`,

        'register': `Registers a node with PowerMTA Management Console.
            
Options:

--user

    PowerMTA Management Console user to be used for registration

--label

    Name of PowerMTA instance that will be shown in PowerMTA Management Console

--webmon-ip

    IP address for PowerMTA Management Console to connect to PowerMTA instance

--webmon-port

    Port for PowerMTA Management Console to connect to PowerMTA instance

--pmtamc-port

    PowerMTA Management Console port to be used for registration

--reuse-label

    If label was previously used, but deregistered, this allows label to be used again

--pmtamc-hostname

    PowerMTA Management Console server to be used for registration
`,

        'reload': `PowerMTA reads its configuration during startup. Use this command to activate the new settings after making changes to the configuration file. The reload command is generally preferable to stopping and restarting PowerMTA because it is more efficient and does not cause an interruption in service.

If PowerMTA detects an error in the configuration file, the reload command fails and the previous in-memory configuration is retained.`,

        'reset counters': `The reset counters command allows you to reset the various counters for statistics shown by PowerMTA in the output of show status command without having to restart the PowerMTA service.`,

        'reset status': `This command is just an alias to reset counters.`,

        'resolve': `The resolve command queries DNS for mail routing information (MX and A/AAAA records) for the specified domain, displays that information, and optionally connects to the first available mailhost. It is intended to facilitate debugging connectivity problems to destination domains. For example, if you notice that the queue is building up for a specific domain, you can run resolve against that domain to figure out what problems exist and what if anything can be done to fix the problem.

Defaults:

If no options are specified, DNS resolution is attempted via UDP and any relevant information is displayed, however no attempt is made to connect to a mailhost.

Options:

--tcp

    this tells PowerMTA to use TCP (rather than the default UDP) for querying the name server(s)

--connect

    this option tells PowerMTA to attempt to connect to the first available mailhost as well, after querying and displaying the specified domain's DNS server for mail routing information.

--dumppackets

    this option tells PowerMTA to print out an hexadecimal dump of any DNS queries and responses exchanged with the name servers. It is ignored unless the output is in textual format.

--interactive

    this option allows the user to try various SMTP commands, to help diagnose problems.

--server

    this option tells PowerMTA which DNS server to connect to when resolving hostnames.

--source

    this option tells PowerMTA the internal IP address or hostname to use during the connection attempt.

--use-dane

    this option tells PowerMTA to lookup DANE DNS records for the connection attempt, and use STARTTLS during the connection attempt based on the remote site's preference as listed in its DANE DNS records. Note that PowerMTA has to be configured with a DNS resolver that supports DNSSEC for this flag to be used. See DANE for more information.
`,

        'resume queue': `Resumes delivery of messages in the queue.`,

        'resume job': `Resumes delivery of messages matching the given jobID.`,

        'rotate acct': `This command instructs PowerMTA to immediately rotate all configured accounting files. If a filename is specified in the command, only that specified accounting file will be rotated. Immediate rotation does not affect the automatic rotation at midnight, which is still performed.`,

        'rotate log': `This command instructs PowerMTA to immediately rotate the logging file. Immediate rotation does not affect the automatic rotation at midnight, which is still performed.`,

        schedule: `Instructs PowerMTA to immediately request workers to be assigned to the specified queue(s) in order to start delivery attempts for messages queued in them. This command would be used, for example, if connectivity problems to a domain were fixed and the normal retry interval should be bypassed. A wildcard can also be specified in domain or vmta, allowing multiple domains/vmtas to be scheduled at once.

Options:

--retry-recipients

    Recipients that received SMTP 4xx errors (such as "mailbox full" error) are placed in a separate retry bucket where they are held for up to a period of time controlled by the per-domain setting retry-recipients-after. This flag overrides the retry-after period for recipients, and immediately makes them available for delivery attempts.
`,

        'set priority': `Sets priority for individual messages that match the given criteria.`,

        'set queue': `Sets the given queue's mode of operation to either normal or backoff. While in backoff mode, various different settings may apply. See the backoff-... directives in <domain> Directives for more information.

Wildcards can be used to modify various queues at the same time.`,

        'show disabled sources': `Shows currently disabled source IPs for the given queue.`,

        'show domains': `This command allows you to view current information on the specified destination domain(s).

Options:

--vmta=name

    displays only domains information for the given VirtualMTA. The default is to display (accumulated) information for all VirtualMTAs, including messages for which no VirtualMTA was selected.

--connected

    displays domains to which PowerMTA has least one open outgoing connection. The default is to display both connected and unconnected domains.

--maxitems=n

    specifies the maximum number of domains to be displayed in the output. By default, 20 domains are displayed.

--errors

    displays any errors recorded for the domain.

--sort=key

    sort output by key where key may be name to order the domain list alphabetically by name, rcpt to order the list by number of recipients or size to order the list by volume (kbytes).

name

    domain name or wildcard specifying the domains about which information is to be displayed. If omitted, all domains are displayed (subject to the maxitems limit).
`,

        'show jobs': `This command allows you to view the jobs currently in PowerMTA's queue.

Options:

--maxitems=n

    specifies the maximum number of queues to be displayed in the output. By default all jobs are displayed.
`,

        'show license': `Allows listing license information from the command line.`,

        'show precache': `Shows currently precached domains.`,
        'show queues': `This command allows you to view current information on the specified queues. The output also includes the last 50 delivery/bounce/deferral events by default.
            
Options:

--connected

    displays queues for which PowerMTA has least one open outgoing connection. The default is to display both connected and unconnected queues.

--mode

    displays only queues in the specified mode. The default is to display queues in all modes.

--maxitems=n

    specifies the maximum number of queues to be displayed in the output. By default, 20 domains are displayed.

--errors

    displays any errors recorded for the queue.

--sort=key

    sort output by key where key may be name to order the queue list alphabetically by name, rcpt to order the list by number of recipients or size to order the list by volume (kbytes).

--no-rcpt-events

    hides the delivery events, that by default are shown.

--paused={yes|no}

    allows selecting only paused or running queues for display. By default, both are shown.

--mode-events

    allows show the recent mode changes

queue

    name of the queue(s) to display, in the format domain[/vmta], where domain is the destination domain name and vmta is the VirtualMTA. If omitted, both domain and vmta default to * (i.e., */*), which matches all queues.
`,

        'show registration': `Shows current PowerMTA Management Console registration information.`,

        'show status': `Displays various statistics and counters since last restart. The output includes totals, top throughput and queue information among other things.`,

        'show settings': `This command allows you to view the (per-queue) settings for the specified domain and VirtualMTA.`,

        'show topdomains': `For displaying the top domains in the queue sorted by number of recipients. Since this command is equivalent to show domains --sort=rcpt, please see show-domains for more information on the various options.`,

        'show topqueues': `For displaying the top queues sorted by number of recipients. Since this command is equivalent to show queues --sort=rcpt, please see show-queues for more information on the various options.`,

        'show version': `Displays PowerMTA's version and build date.`,

        'show vmtas': `This command displays a summary of the VirtualMTA(s) in use, as well as the number of recipients and message size in kilobytes within the VirtualMTA.
            
Options:

--maxitems=n

    specifies the maximum number of queues to be displayed in the output. By default all vmtas are displayed.
`,
        'show vmta-settings': `Shows the settings for the specified VirtualMTA.`,

        'test config': `Can be used to verify whether the syntax of the configuration file is correct without reloading PMTA's running configuration.`,

        'trace': `Instructs PowerMTA to open a connection to the specified domain and to attempt delivery of a single message from the queue. This command is similar to the schedule command, with the difference that it also automatically enables logging for the domain for the duration of one connection. If the --to-log switch is used, it is a shortcut to enabling logging in the configuration file, reloading the configuration, scheduling a call and undoing these changes when debugging is finished. By default, only the SMTP commands and responses are logged. The result of this command is written to the logging file.
            
Options:

--log-data

    this enables logging of data transfers as well, like the log-data option in the configuration file.

--log-resolution

    this enables logging of the DNS resolution as well, like the log-resolution option in the configuration file.

--to-log

    this enables logging trace info to the log file

--retry-recipients

    Use of the retry-recipients flag will cause all the recipients of the queue that are in Await Retry bucket to become available for retry immediately.

--source-ip

    Specifies the source IP used for connection attempts from a virtual mta with multiple smtp-source-hosts configured in it

domain[/vmta]

    name of the queue(s) to display, where domain is the destination domain name and vmta is the VirtualMTA. If omitted, both domain and vmta default to * (i.e., */*), which matches all queues.
`
}
    

/**
 * Helper functions to format various aspects of commands (e.g. name and help output).
 */
export default class CommandFormatter {
    /**
     * Returns command name for the given syntax.
     *
     * @param syntax
     *      full syntax of the command (e.g. "clear dnscache domainname").
     * @return
     *      command name (e.g. "clear dnscache")
     */
    getCommandName(syntax) {
        const commandNames = Object.keys(availableCommands)
        for (let i = 0; i < commandNames.length; i++) {
            if (syntax.indexOf(commandNames[i]) !== -1) {
                return commandNames[i]
            }
        }
        return syntax
    }


    /**
     * Returns help for the given command.
     *
     * @param commandSyntax
     *      full syntax of the command for which help is desired.
     * @return
     *      command help in the format:
     *          {
     *              name: 'commandName',
     *              help: 'commandHelp'
     *          }
     */
    getCommandHelp(commandSyntax) {
        const syntax = commandSyntax ? commandSyntax.toLowerCase() : ''
        const help = availableCommands[getCommandName(syntax)]
        return help ? { name: syntax, help: help } : undefined
    }
}


export let getCommandName = new CommandFormatter().getCommandName
export let getCommandHelp = new CommandFormatter().getCommandHelp
